<template>
  <div class="qs-card" v-if="suggestions && suggestions.length">
    <div class="qs-title">{{ title }}</div>
    <div class="qs-list">
      <button
        v-for="(item, index) in suggestions"
        :key="index"
        class="qs-item"
        type="button"
        @click="handleClick(item, index)"
      >
        <span class="qs-icon" aria-hidden="true">{{ item.icon }}</span>
        <span class="qs-text">{{ item.text }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestionSuggestions",
  props: {
    title: {
      type: String,
      default: "试试向我提问吧",
    },
    suggestions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(item, index) {
      this.$emit("select", item, index);
    },
  },
};
</script>

<style scoped lang="scss">
.qs-card {
  width: 94%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 18px 8px 12px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.35),
    rgba(255, 255, 255, 0.55)
  );
  border-radius: 20px;
  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.65);
  position: relative;
  z-index: 10;
  backdrop-filter: blur(16px) saturate(1.2);
  -webkit-backdrop-filter: blur(16px) saturate(1.2);
  overflow: hidden;
}

.qs-title {
  color: #2a6bd1;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
}

.qs-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
}

.qs-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 10px;
  border-radius: 999px;
  border: 1px solid #e6e8ef;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  font-size: 10px;
  color: #4a4d55;
  text-align: left;
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.2s ease;
}

.qs-item:active {
  transform: translateY(1px);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.qs-icon {
  font-size: 18px;
  line-height: 1;
}

.qs-text {
  flex: 1;
  line-height: 1.4;
  word-break: break-word;
}
</style>

